import { useState } from "react";
import { Switch } from "@/components/ui/switch";
import StepShell from "../StepShell";
import * as api from "../briefingService";

const ADVBOX_AUTOMATIONS = [
  { id: "aniversariante", label: "Aniversariante do dia" },
  { id: "avisoAudiencia", label: "Aviso de audiência" },
  { id: "avisoPericia", label: "Aviso de perícia" },
  { id: "embarque", label: "Embarque do cliente" },
  { id: "processoSemMovimentacao", label: "Processo sem movimentação" },
  { id: "solicitacaoDocumentos", label: "Solicitação de documentos" },
];

/**
 * Comportamento do AdvBox — o que um novo lead vira, automações a ligar e a
 * consulta de processo pelo WhatsApp. Usa a rota dedicada de integrações
 * (merge server-side) para não sobrescrever o pendingToken criptografado.
 */
export default function AdvboxConfig({ clientId, briefing }) {
  const ic = briefing.integrationsConfig || {};
  const [advbox, setAdvbox] = useState(
    ic.advbox || { createsContact: true, createsTask: false, automations: {} },
  );
  const [errorMsg, setErrorMsg] = useState("");

  function persist(patch) {
    api
      .saveIntegrations(clientId, patch)
      .catch((err) => setErrorMsg(err.message || "Falha ao salvar integrações."));
  }

  function setAdvboxField(patch) {
    const next = { ...advbox, ...patch };
    setAdvbox(next);
    persist({ advbox: next });
  }

  function toggleAutomation(id, value) {
    const automations = { ...(advbox.automations || {}), [id]: value };
    setAdvboxField({ automations });
  }

  return (
    <StepShell
      title="Automações AdvBox"
      description="Quais automações do Advbox vocês querem ativar?"
    >

      <h3 className="mb-3 mt-6 text-sm font-medium text-foreground">Automações a ligar</h3>
      <div className="space-y-2">
        {ADVBOX_AUTOMATIONS.map((a) => (
          <ToggleRow
            key={a.id}
            label={a.label}
            checked={!!advbox.automations?.[a.id]}
            onChange={(v) => toggleAutomation(a.id, v)}
          />
        ))}
      </div>

      {errorMsg && <p className="mt-4 text-sm text-destructive">{errorMsg}</p>}
    </StepShell>
  );
}

function ToggleRow({ label, checked, onChange }) {
  return (
    <label className="flex cursor-pointer items-center justify-between gap-4 rounded-xl border border-border bg-surface px-4 py-3">
      <span className="text-sm text-foreground">{label}</span>
      <Switch checked={checked} onCheckedChange={onChange} />
    </label>
  );
}
